import React from "react";
import NuMultiSelect from "./NuMultiSelect";
import NuSingleSelect from "./NuSingleSelect";
import StandardModal from "./shared/StandardModal";
import moment from "moment";
import { PrimaryButton } from "./shared/button/PrimaryButton";
import { SecondaryButton } from "./shared/button/SecondaryButton";
import { useClassroomPolicyStore } from "stores/v2/classroomPolicyStore";
import { withTranslation } from "react-i18next";
import { useSignatureStore } from "@/stores/v2/signatureStore";

class RewardModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			reward_apps:
				useClassroomPolicyStore.getState().getRewardApps().length > 0
					? useClassroomPolicyStore.getState().getRewardApps()
					: ["sphirewall.application.socialmedia", "sphirewall.application.gaming"],
			reward_websites:
				useClassroomPolicyStore.getState().getRewardWebsites().length > 0 ? useClassroomPolicyStore.getState().getRewardWebsites() : [],
			reward_active_until: useClassroomPolicyStore.getState().getRewardActiveUntil()
				? useClassroomPolicyStore.getState().getRewardActiveUntil()
				: 0,
			timeframe: "600",
			active: false,
		};
	}

	componentDidMount = () => {
		this.timer = setInterval(this.reward_timer, 1000);
	};

	componentWillUnmount = () => {
		clearInterval(this.timer);
	};

	reset = () => {
		this.setState({
			reward_apps: ["sphirewall.application.socialmedia", "sphirewall.application.gaming"],
			reward_websites: [],
			reward_active_until: 0,
			timeframe: "600",
		});
	};

	startReward = () => {
		const activeUntil = moment().unix() + parseInt(this.state.timeframe);
		this.setState({
			reward_active_until: activeUntil,
		});
		useClassroomPolicyStore.getState().setReward({
			apps: this.state.reward_apps,
			websites: this.state.reward_websites,
			active_until: activeUntil,
		});
		this.handleClose();
	};

	updateReward = () => {
		useClassroomPolicyStore.getState().setReward({
			apps: this.state.reward_apps,
			websites: this.state.reward_websites,
			active_until: this.state.reward_active_until,
		});
		this.handleClose();
	};

	stopReward = () => {
		this.reset();
		useClassroomPolicyStore.getState().setReward({
			apps: [],
			websites: [],
			active_until: 0,
			timeframe: "600",
		});
		this.handleClose();
	};

	handleClose = () => {
		this.props.onClose();
	};

	prepareSignatures = () => {
		const { t } = this.props;
		const ret = [];
		const availableSignatures = useSignatureStore.getState().signatures;

		for (const signature of availableSignatures) {
			if (
				signature.enabled &&
				signature.id !== "sphirewall.application.porn" &&
				signature.id !== "sphirewall.application.childporn" &&
				signature.id !== "sphirewall.application.offensive"
			) {
				ret.push({ value: signature.id, text: signature.name });
			}
		}

		ret.push({
			shouldShow: function (value) {
				return this.isOk(value);
			},
			renderText: function (value) {
				return t("rewardModal.websiteEntry", { value });
			},
			isOk: function (value) {
				return this.transformFilter(value) !== "";
			},
			transformFilter: function (value) {
				const re = /^(http:\/\/|https:\/\/|)([a-z0-9A-Z.]+\.?)\.([a-z0-9A-Z.]+)(\/|)([a-z0-9A-Z.\-%_#&?=]+|)/i;
				let url = "";
				if (re.test(value)) {
					const m = re.exec(value);
					if (m[2] !== "") {
						url += m[2];
					}
					if (m[3] !== "") {
						url += "." + m[3];
					}
					if (m[4] !== "") {
						url += m[4];
					}
					if (m[5] !== "") {
						url += m[5];
					}
				}
				return url;
			},
			dynamic: true,
			value: "website",
		});

		return ret;
	};

	processSelectedItems = () => {
		const ret = [];
		for (const x of this.state.reward_apps) {
			ret.push(x);
		}

		for (const x of this.state.reward_websites) {
			ret.push(x);
		}
		return ret;
	};

	handleAddRewardApp = (tag) => {
		if (useSignatureStore.getState().findSignature(tag) !== undefined) {
			this.setState({
				reward_apps: this.state.reward_apps.concat([tag]),
			});
		} else {
			this.setState({
				reward_websites: this.state.reward_websites.concat([tag]),
			});
		}
	};

	handleRemoveRewardApp = (tag) => {
		if (useSignatureStore.getState().findSignature(tag) !== undefined) {
			const tmpRewardApps = this.state.reward_apps;
			const index = tmpRewardApps.indexOf(tag);
			if (index >= 0) {
				tmpRewardApps.splice(index, 1);
				this.setState({
					reward_apps: tmpRewardApps,
				});
			}
		} else {
			const tmpRewardWebsites = this.state.reward_websites;
			const index = tmpRewardWebsites.indexOf(tag);
			if (index >= 0) {
				tmpRewardWebsites.splice(index, 1);
				this.setState({
					reward_websites: tmpRewardWebsites,
				});
			}
		}
	};

	prepareRewardDuration = () => {
		const { t } = this.props;
		const ret = [];
		ret.push({ value: "600", text: t("rewardModal.duration10Minutes") });
		ret.push({ value: "900", text: t("rewardModal.duration15Minutes") });
		ret.push({ value: "1200", text: t("rewardModal.duration20Minutes") });
		ret.push({ value: "1800", text: t("rewardModal.duration30Minutes") });
		ret.push({ value: "2700", text: t("rewardModal.duration45Minutes") });
		ret.push({ value: "3600", text: t("rewardModal.duration1Hour") });
		ret.push({ value: "7200", text: t("rewardModal.duration2Hours") });
		ret.push({ value: "10800", text: t("rewardModal.duration3Hours") });
		return ret;
	};

	changeRewardDuration = (value) => {
		this.setState({
			timeframe: value,
		});
	};

	reward_timer = () => {
		const active = this.state.reward_active_until > moment().unix();
		const end = moment.utc(this.state.reward_active_until, "X");
		const timeLeft = moment.utc(end.diff(moment.utc()));
		if (this.state.active !== active) {
			this.setState({
				active: active,
				// rewardTimeLeft: timeLeft.hours() + " hours " + timeLeft.minutes() + " minutes"
			});
			if (this.props.isActive) {
				this.props.isActive(active);
			}
		}
		const rewardTTL = document.getElementById("rewardTimeLeft");
		if (rewardTTL) {
			rewardTTL.innerText = timeLeft.format("HH:mm:ss");
		}
	};

	renderActions = () => {
		const { t } = this.props;
		if (this.state.active) {
			return (
				<React.Fragment>
					<SecondaryButton className="mui-flat-button secondary_btn" label={t("rewardModal.buttonStop")} onClick={this.stopReward} />
					<PrimaryButton className="mui-flat-button" label={t("rewardModal.buttonUpdate")} onClick={this.updateReward} />
				</React.Fragment>
			);
		}
		return (
			<React.Fragment>
				<PrimaryButton className="mui-flat-button" label={t("rewardModal.buttonStart")} onClick={this.startReward} />
			</React.Fragment>
		);
	};

	renderTimeSelection = () => {
		const { t } = this.props;
		if (this.state.active) {
			return (
				<div>
					{t("rewardModal.timeLeftHeading")} <span id={"rewardTimeLeft"} />{" "}
					{t("rewardModal.timeLeftEndsAt", {
						date: moment(this.state.reward_active_until, "X").format("LLL"),
					})}
				</div>
			);
		} else {
			return (
				<NuSingleSelect
					allItems={this.prepareRewardDuration()}
					selectedItem={this.state.timeframe}
					searchPlaceholder={t("rewardModal.rewardDurationPlaceholder")}
					title={t("rewardModal.rewardDurationTitle")}
					onChange={this.changeRewardDuration}
				/>
			);
		}
	};

	render() {
		const { t } = this.props;
		return (
			<StandardModal
				size="medium"
				title={t("rewardModal.modalTitle")}
				actions={this.renderActions()}
				open={this.props.open}
				close={this.handleClose}
			>
				<form onSubmit={(ev) => ev.preventDefault()}>
					<div>{this.renderTimeSelection()}</div>
					<br />
					<div>
						<NuMultiSelect
							allItems={this.prepareSignatures()}
							selectedItems={this.processSelectedItems()}
							searchPlaceholder={t("rewardModal.searchPlaceholder")}
							selectedPlaceholder={t("rewardModal.selectedPlaceholder")}
							onAdd={this.handleAddRewardApp}
							onRemove={this.handleRemoveRewardApp}
							title={t("rewardModal.applicationsWebsitesTitle")}
						/>
					</div>
				</form>
			</StandardModal>
		);
	}
}

export default withTranslation()(RewardModal);
